/**
 * RegistRejReasonCode
 * - Tag: 507
 * - FIX Specification type: int
 * - Mapped type: number
 * @readonly
 * @public
 */
export const RegistRejReasonCode = Object.freeze({
    /** Invalid/unacceptable Account Type */
    InvalidAccountType: 1,
    /** Invalid/unacceptable Tax Exempt Type */
    InvalidTaxExemptType: 2,
    /** Invalid/unacceptable Ownership Type */
    InvalidOwnershipType: 3,
    /** Invalid/unacceptable No Reg Details */
    NoRegDetails: 4,
    /** Invalid/unacceptable Reg Seq No */
    InvalidRegSeqNo: 5,
    /** Invalid/unacceptable Reg Details */
    InvalidRegDetails: 6,
    /** Invalid/unacceptable Mailing Details */
    InvalidMailingDetails: 7,
    /** Invalid/unacceptable Mailing Instructions */
    InvalidMailingInstructions: 8,
    /** Invalid/unacceptable Investor ID */
    InvalidInvestorID: 9,
    /** Invalid/unaceeptable Investor ID Source */
    InvalidInvestorIDSource: 10,
    /** Invalid/unacceptable Date Of Birth */
    InvalidDateOfBirth: 11,
    /** Invalid/unacceptable Investor Country Of Residence */
    InvalidCountry: 12,
    /** Invalid/unacceptable No Distrib Instns */
    InvalidDistribInstns: 13,
    /** Invalid/unacceptable Distrib Percentage */
    InvalidPercentage: 14,
    /** Invalid/unacceptable Distrib Payment Method */
    InvalidPaymentMethod: 15,
    /** Invalid/unacceptable Cash Distrib Agent Acct Name */
    InvalidAccountName: 16,
    /** Invalid/unacceptable Cash Distrib Agent Code */
    InvalidAgentCode: 17,
    /** Invalid/unacceptable Cash Distrib Agent Acct Num */
    InvalidAccountNum: 18,
    /** Other */
    Other: 99,
} as const);

type RegistRejReasonCode = (typeof RegistRejReasonCode)[keyof typeof RegistRejReasonCode];
